import { useEffect, useRef, useState } from 'react';

export function QuickCapture({ evening, busy, onSubmit }: { evening: boolean; busy: boolean; onSubmit(text: string): Promise<void> }) {
  const [text, setText] = useState('');
  const textRef = useRef(text);
  useEffect(() => { textRef.current = text; }, [text]);
  const submit = async () => {
    const value = textRef.current.trim();
    if (!value || busy) return;
    await onSubmit(value);
    textRef.current = '';
    setText('');
  };
  return <div className="capture-wrap">
    <div className="quick-capture teacher-capture">
      <textarea
        value={text}
        onChange={(event) => { textRef.current = event.target.value; setText(event.target.value); }}
        rows={8}
        placeholder={evening ? 'Вставьте полный текст одного персонажа…' : 'Один персонаж — один полный текст…'}
        onKeyDown={(event) => { if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') void submit(); }}
      />
      <div className="teacher-capture-footer">
        <span>{text.length.toLocaleString('ru-RU')} знаков</span>
        <button className="impulse-button" disabled={!text.trim() || busy} onClick={() => void submit()}>{busy ? 'Обработка…' : 'Разметить'}</button>
      </div>
    </div>
  </div>;
}
